var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isMobilePort
        ? [_c("browse-codes-sections"), _vm._v(" "), _c("top-banner-section")]
        : [_c("top-banner-section"), _vm._v(" "), _c("browse-codes-sections")],
      _vm._v(" "),
      _c("premium-tools"),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "text-center pb-12 content-container" },
        [
          _c(
            "p",
            { staticClass: "mb-3 text-body-1" },
            [
              _c(
                "v-avatar",
                {
                  staticClass: "rounded-xl mr-1",
                  attrs: { size: "24", color: "accent2Light" },
                },
                [
                  _c(
                    "v-icon",
                    { attrs: { size: "16", color: "grey darken-4" } },
                    [_vm._v("mdi-creation")]
                  ),
                ],
                1
              ),
              _vm._v(
                "\n            Try these tools and more free for 14 days with Premium Complete\n        "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("start-free-trial", {
            staticClass: "mr-2 tracking_home_btn_free_trial",
          }),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "tracking_home_btn_learn_more focus-buttons-offset",
              attrs: {
                outlined: "",
                large: "",
                href: _vm.getRoute("premium_features"),
              },
            },
            [_vm._v("Learn More")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "hero-section",
        { staticClass: "py-8 grey lighten-4" },
        [_c("upsell-mobile")],
        1
      ),
      _vm._v(" "),
      _c(
        "hero-section",
        { staticClass: "py-5" },
        [_c("popular-publishers")],
        1
      ),
      _vm._v(" "),
      _c(
        "hero-section",
        { staticClass: "grey lighten-4" },
        [_c("customer-testimonials")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "primary py-10 elevation-2" },
        [_c("premium-compare")],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "content-container" },
        [_c("category-map")],
        1
      ),
      _vm._v(" "),
      _c(
        "hero-section",
        { staticClass: "py-2" },
        [_c("popular-code-collections")],
        1
      ),
      _vm._v(" "),
      _c("hero-section", { staticClass: "grey lighten-4 py-5" }, [
        _c(
          "div",
          { staticClass: "roboto" },
          [
            _c(
              "h3",
              { staticClass: "primary--text text-uppercase text-center mb-5" },
              [_vm._v("Contents by Industry Topic")]
            ),
            _vm._v(" "),
            _c(
              "v-row",
              _vm._l(_vm.contentsByIndustryTopic, function (item, i) {
                return _c(
                  "v-col",
                  { key: i, attrs: { cols: "12", lg: "4" } },
                  [
                    _c("v-avatar", {
                      staticClass: "mr-2",
                      attrs: { color: "#FFA201", size: "5", rounded: "0" },
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      { attrs: { href: _vm.getTopicUrlFromName(item) } },
                      [_vm._v(_vm._s(item))]
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("hero-section", [_c("stay-connected")], 1),
      _vm._v(" "),
      _c(
        "hero-section",
        { staticClass: "py-8 elevation-2 primary" },
        [_c("who-we-are")],
        1
      ),
      _vm._v(" "),
      _c(
        "hero-section",
        { staticClass: "py-8" },
        [_c("frequently-asked-questions")],
        1
      ),
      _vm._v(" "),
      _c("hero-section", { staticClass: "py-5" }, [_c("subscribe-now")], 1),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }